module.exports = __webpack_public_path__ + "img/contraste1.fc3ed90c.png";